import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavigationBar from './components/Navbar';
import HeroCarousel from './components/HeroCarousel';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import AndroidPrivacyPolicy from './components/android_privacy_policy';
import IosPrivacyPolicy from './components/IosPrivacyPolicy';
import DogIdentifierPage from './components/DogIdentifierPage';
import DogIdentifierPrivacyPolicy from './components/DogIdentifierPrivacyPolicy';
import DogIdentifierTerms from './components/DogIdentifierTerms';
import DeleteAccount from './components/DeleteAccount';

function HomePage() {
  return (
    <>
      <HeroCarousel />
      <Services />
      <Portfolio />
      <Testimonials />
      <AboutUs />
      <Contact />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <NavigationBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ios_privacy_policy" element={<IosPrivacyPolicy />} />
          <Route path="/android_privacy_policy" element={<AndroidPrivacyPolicy />} />
          <Route path="/dog-identifier" element={<DogIdentifierPage />} />
          <Route path="/dog-identifier/privacy-policy" element={<DogIdentifierPrivacyPolicy />} />
          <Route path="/dog-identifier/terms" element={<DogIdentifierTerms />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;